import { render } from "./App.vue?vue&type=template&id=696488f6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=696488f6&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__